import axios from 'axios'

export function useApi(config = {}) {
    const apiBaseUrl = config.apiBaseUrl || window.AUDIENCE_CONFIG?.apiBaseUrl || ''
    const authToken = config.authToken || window.AUDIENCE_CONFIG?.authToken || null

    const api = axios.create({
        baseURL: apiBaseUrl,
        headers: {
            'Content-Type': 'application/json',
            ...(authToken && { 'Authorization': `Bearer ${authToken}` })
        }
    })

    // Add request interceptor for debugging
    api.interceptors.request.use(
        (config) => {
            console.log('API Request:', config.method?.toUpperCase(), config.url)
            return config
        },
        (error) => {
            console.error('API Request Error:', error)
            return Promise.reject(error)
        }
    )

    // Add response interceptor for error handling
    api.interceptors.response.use(
        (response) => response,
        (error) => {
            console.error('API Response Error:', error.response?.status, error.response?.data)
            return Promise.reject(error)
        }
    )

    return { api }
}